import React, { useState, useRef, useMemo, useCallback } from "react";
import './style.scss'

// import HeaderMenu from './Component/HeaderMenu'
import ReviewContent from "./Component/ReviewContent";

const Review = () => {
    const [ Data, SetData ] = useState(null);
    return (
        <div className={"bpl-container"}>
            <section className={"review-compare"}>
                <ReviewContent {...Data} />
            </section>
        </div>
    );
};

export default Review;
